export interface VendorFlagsPercentages {
  high: number;
  medium: number;
  low: number;
}

export const EmptyVendorFlagsPercentages: VendorFlagsPercentages = {
  high: 0,
  medium: 0,
  low: 0,
};
